import { useEffect, useState } from "react"
import { CampProps } from "../interfaces"
import ReactGA from "react-ga4"

const PARK_GA_ID = "G-KGQBEWW0K0"

const useGoogleAnalytics = (camp: CampProps) => {
  const campGoogleAnalyticsId = camp?.google_analytics_id
  const campGoogleAdsId = camp?.google_ads_id
  const campGoogleAdConversionId = camp?.google_ad_conversion_id

  useEffect(() => {
    ReactGA.initialize(PARK_GA_ID)
    if (campGoogleAnalyticsId) ReactGA.initialize(campGoogleAnalyticsId)
  }, [campGoogleAnalyticsId])

  const trackForPark = (action: string, params: object = {}) => {
    ReactGA.event(action, { send_to: PARK_GA_ID, ...params })
  }

  const trackForCamp = (action: string, params: object = {}) => {
    if (campGoogleAnalyticsId) {
      ReactGA.event(action, { send_to: campGoogleAnalyticsId, ...params })
    }
  }

  const trackAdConversionForCamp = (action: string, params: object = {}) => {
    if (!campGoogleAdConversionId) {
      console.warn("No Ad Conversion ID provided.")
      return
    }

    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: campGoogleAdsId + "/" + campGoogleAdConversionId,
        value: params["value"],
        currency: params["currency"],
      })
    } else {
      console.warn("gtag is not defined. Please ensure the gtag script is loaded.")
    }
  }

  return { trackForPark, trackForCamp, trackAdConversionForCamp }
}

export default useGoogleAnalytics
